import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { filter, Observable, takeUntil } from 'rxjs';

import { GoogleMapsLoaderService } from '@usheru-hff/shared/feature-location-selector';
import { Dialog } from 'primeng/dialog';

/**

 * Shows a PrimeNG dialog with google map and a marker.

 *

 *  //TODO barbeitoalex propostal - organice life cycle methods. Split in specific method to improve docs.

 */

@Component({
  selector: 'ush-modal-map',

  templateUrl: './modal-map.component.html',

  styleUrls: ['./modal-map.component.scss'],

  changeDetection: ChangeDetectionStrategy.Default,

  encapsulation: ViewEncapsulation.None
})
export class ModalMapComponent implements AfterViewInit, OnDestroy {
  @ViewChild(Dialog) dialog: Dialog;

  /**
   * latitude
   */
  @Input()
  lat: number | string;

  /**
   * longitude
   */
  @Input()
  lng: number | string;

  /**
   * Address to show in the header dialog.
   */
  @Input()
  address = '';

  /**
   * Controls dialog status to show it.
   */
  @Input()
  visible = true;

  @Input()
  inlineMap = false;

  /**
   * Emits that the dialog was close.
   */
  @Output()
  hide = new EventEmitter<boolean>();

  /**
   * Element reference that contains the google map
   */
  @ViewChild('mapElement')
  mapElement: ElementRef;

  /**
   * @deprecard Don't found any use
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any;

  /**
   * @deprecard Don't found any use
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  overlays: any[] = [];

  destroy$ = new EventEmitter<void>();

  constructor(private googleMapsLoader: GoogleMapsLoaderService) {}

  /**
   * * Initis the map and set a marker. The map data can not be updated.
   */
  ngAfterViewInit() {
    if (this.dialog) {
      // The element is rendered after the dialog is opened not at the same time.
      // The maskClickListener is not triggered.
      setTimeout(() => {
        if (this.dialog.wrapper) {
          this.dialog.wrapper.addEventListener('click', () => {
            this.onClickMask();
          });
        } else {
          console.warn('Dialog wrapper not found');
        }
      }, 100);
    }

    if (!this.googleMapsLoader.$mapsLoaded.value) {
      this.initializeGoogleMaps()

        .pipe(takeUntil(this.destroy$))

        .subscribe(() => {
          this.initializeModalMap();
        });
    } else {
      this.initializeModalMap();
    }
  }

  initializeGoogleMaps(): Observable<boolean> {
    this.googleMapsLoader.loadGoogleMapsScripts();
    return this.googleMapsLoader.$mapsLoaded.pipe(filter(Boolean));
  }

  initializeModalMap() {
    const map = new google.maps.Map(this.mapElement.nativeElement, {
      center: {
        lat: Number(this.lat),
        lng: Number(this.lng)
      },
      zoom: 12
    });

    new google.maps.Marker({
      position: {
        lat: Number(this.lat),
        lng: Number(this.lng)
      },
      map,
      title: this.address
    });
  }

  onVisibleChange(event) {
    this.hide.emit(event);
  }

  onClickMask() {
    this.dialog.close(new Event('close'));
  }

  ngOnDestroy(): void {
    this.destroy$.emit();
    this.destroy$.complete();
  }
}
